import AxiosClient from "../AxiosClient";

/**
 *
 * @param {*} orderDate 注文した日付
 * @param {*} customerId 注文した買人ID
 * @returns
 */
export const getChainStoreOrder = (shipmentDate, buyerNo, priceDetailTypeId) => {
  const params = { shipmentDate, buyerNo, priceDetailTypeId };
  const url = "/api/chainStore/searchOrderInfoList";
  return AxiosClient.post(url, params);
};

/**
 *
 * @param {*} slipNo 伝票番号
 * @returns
 */
export const getChainStoreBySlipNo = (slipNo) => {
  const params = { slipNo };
  const url = "/api/chainStore/searchInfoList";
  return AxiosClient.post(url, params);
};

/**
 *
 * @param {*} customerId 注文した買人ID
 * @returns
 */
export const getProductMapping = (buyerNo) => {
  const params = { buyerNo };
  const url = "/api/chainStore/searchProductMappingInfoList";
  return AxiosClient.post(url, params);
};

export const upsertChainStore = (data) => {
  const url = "/api/chainStore/upsertInfo";
  return AxiosClient.post(url, data);
};

/**
 *
 * @param {*} customerId 
 * @returns
 */
export const getChainStoreProduct = (params) => {
  const url = "/api/chainStoreProduct/searchInfoList";
  return AxiosClient.post(url, params);
};
export const insertChainStoreProduct = (params) => {
  const url = "/api/chainStoreProduct/insertInfo";
  return AxiosClient.post(url, params);
};
export const updateChainStoreProduct = (params) => {
  const url = "/api/chainStoreProduct/updateInfo";
  return AxiosClient.post(url, params);
};
export const deleteChainStoreProduct = (params) => {
  const url = "/api/chainStoreProduct/deleteInfo";
  return AxiosClient.post(url, params);
};